export const pascalToKebabConverter = (string) => {
    const result = string
        .replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2')
        .toLowerCase();
    return result.startsWith('-') ? result.substr(1) : result;
};
//# sourceMappingURL=pascalToKebab.js.map